import { type FC } from 'react';

interface FilterOption {
  label: string;
  value: string;
}

interface FilterBarProps {
  filters: {
    key: string;
    label: string;
    options: FilterOption[];
    value: string;
    onChange: (value: string) => void;
  }[];
  className?: string;
}

const FilterBar: FC<FilterBarProps> = ({ filters, className = '' }) => {
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      {filters.map((filter) => (
        <div key={filter.key} className="flex items-center gap-1.5">
          <label className="text-xs text-foreground-500 font-medium whitespace-nowrap">{filter.label}</label>
          <select
            value={filter.value}
            onChange={(e) => filter.onChange(e.target.value)}
            className="text-xs px-2.5 py-1.5 bg-background-50 border border-background-200 rounded-lg text-foreground-700 focus:outline-none focus:border-primary-300 cursor-pointer"
          >
            <option value="">Todos</option>
            {filter.options.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>
      ))}
    </div>
  );
};

export default FilterBar;